export default __webpack_public_path__ + "static/media/about-bg.ebd83560.png";